/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditLogResponseDto } from '../models/AuditLogResponseDto';
import type { ListAuditLogsResponseDto } from '../models/ListAuditLogsResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuditLogsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * List all audit logs (admin only)
   * @returns ListAuditLogsResponseDto Audit logs retrieved successfully
   * @throws ApiError
   */
  public auditLogsControllerFindAll({
    page = 1,
    limit = 20,
    entityType,
    entityId,
    action,
    userId,
    sortBy = 'createdAt',
    sortOrder = 'desc',
  }: {
    /**
     * Page number (1-indexed)
     */
    page?: number,
    /**
     * Items per page
     */
    limit?: number,
    /**
     * Filter by entity type
     */
    entityType?: 'Organization' | 'User' | 'Location' | 'AssetType' | 'Asset' | 'Maintenance' | 'Movement',
    /**
     * Filter by entity ID (UUID)
     */
    entityId?: string,
    /**
     * Filter by action type
     */
    action?: 'CREATE' | 'UPDATE' | 'DELETE',
    /**
     * Filter by user ID (UUID)
     */
    userId?: string,
    /**
     * Order by field
     */
    sortBy?: 'createdAt',
    /**
     * Sort order
     */
    sortOrder?: 'asc' | 'desc',
  }): CancelablePromise<ListAuditLogsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/audit-logs',
      query: {
        'page': page,
        'limit': limit,
        'entityType': entityType,
        'entityId': entityId,
        'action': action,
        'userId': userId,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden - Admin only`,
      },
    });
  }
  /**
   * Get a single audit log by ID (admin only)
   * @returns AuditLogResponseDto Audit log retrieved successfully
   * @throws ApiError
   */
  public auditLogsControllerFindOne({
    id,
  }: {
    id: string,
  }): CancelablePromise<AuditLogResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/audit-logs/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden - Admin only`,
        404: `Audit log not found`,
      },
    });
  }
}
